// Path: app\arch\routes\router.tsx
import { lazy } from "react";

import { Routes, Route, Navigate } from "react-router-dom";

import { Protected } from "@arch/routers/utils/protected";
import { AppLayout } from "@boundary/layouts/appLayout";

import { SplashPage } from "@boundary/pages/1.splash/splashPage";
import { SplashGlowPreviewPage } from "@boundary/pages/22.splashGlowPreview/splashGlowPreview";
import { AboutPage } from "@boundary/pages/2.about/about";
import { LoginPage } from "@boundary/pages/3.login";
import { OnboardingPage } from "@boundary/pages/4.onboarding";
import { MapPage } from "@boundary/pages/5.map/map";
import { CatalogPage } from "@boundary/pages/6.catalog/catalog";
import { ServiceVariantsPage } from "@boundary/pages/6a.serviceVariants/serviceVariants";
import { ServicePage } from "@boundary/pages/7.service/service";
import { DocViewPage } from "@boundary/pages/8.docview/docView";
import { CartPage } from "@boundary/pages/9.cart/cart";
import { PaymentPage } from "@boundary/pages/10.payment/payment";
import { PaymentStatusPage } from "@boundary/pages/10.payment/paymentStatus";
import { OrderPage } from "@boundary/pages/11.order/order";
import { MenuPage } from "@boundary/pages/12.menu/menu";
import { HistoryPage } from "@boundary/pages/14.history/history";
import { ScreenBackgroundsGalleryPage } from "@boundary/pages/19.screenBackgroundsGallery/screenBackgroundsGallery";
import { VisualDomainPreviewPage } from "@boundary/pages/21.visualDomain/visualDomainPreview";

const ProfilePage = lazy(() => import("@boundary/pages/13.profile/profile").then(m => ({ default: m.ProfilePage })));
const DiscountsPage = lazy(() => import("@boundary/pages/15.discounts/promos").then(m => ({ default: m.DiscountsPage })));
const PaymentSettingsPage = lazy(() => import("@boundary/pages/16.paymentSettings/paymentMethods").then(m => ({ default: m.PaymentSettingsPage })));
const SupportPage = lazy(() => import("@boundary/pages/17.support/support").then(m => ({ default: m.SupportPage })));
const FAQPage = lazy(() => import("@boundary/pages/18.faq/faq").then(m => ({ default: m.FAQPage })));
const ReferralPage = lazy(() => import("@boundary/pages/23.referral/referral").then(m => ({ default: m.ReferralPage })));
const ReferralProgramPage = lazy(() => import("@boundary/pages/24.referralProgram/referralProgram").then(m => ({ default: m.ReferralProgramPage })));
const BonusesPage = lazy(() => import("@boundary/pages/26.bonuses/bonuses").then(m => ({ default: m.BonusesPage })));
const PartnerIdentityPage = lazy(() => import("@boundary/pages/25.partnerIdentity/partnerIdentity").then(m => ({ default: m.PartnerIdentityPage })));

export function AppRouter() {
    return (
        <Routes>
            <Route element={<AppLayout />}>
                <Route path="*" element={<Navigate to="/" replace />} />
                <Route path="/" element={<SplashPage />} />
                <Route path="/splash-glow-preview" element={<SplashGlowPreviewPage />} />

                <Route path="/about" element={<AboutPage />} />
                <Route path="/screen-backgrounds" element={<ScreenBackgroundsGalleryPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/onboarding" element={<OnboardingPage />} />

                <Route path="/map" element={<Protected><MapPage /></Protected>} />
                <Route path="/catalog" element={<Protected><CatalogPage /></Protected>} />
                <Route path="/service-variants" element={<Protected><ServiceVariantsPage /></Protected>} />
                <Route path="/service" element={<Protected><ServicePage /></Protected>} />

                <Route path="/docview" element={<Protected><DocViewPage /></Protected>} />

                <Route path="/cart" element={<Protected><CartPage /></Protected>} />
                <Route path="/visual/:domain" element={<Protected><VisualDomainPreviewPage /></Protected>} />
                <Route path="/payment" element={<Protected><PaymentPage /></Protected>} />
                <Route path="/payment/status" element={<Protected><PaymentStatusPage /></Protected>} />

                <Route path="/order/:id" element={<Protected><OrderPage /></Protected>} />
                <Route path="/order/history" element={<Protected><HistoryPage /></Protected>} />

                <Route path="/menu" element={<Protected><MenuPage /></Protected>} />
                <Route path="/profile" element={<Protected><ProfilePage /></Protected>} />
                <Route path="/payment/settings" element={<Protected><PaymentSettingsPage /></Protected>} />
                <Route path="/support" element={<Protected><SupportPage /></Protected>} />
                <Route path="/faq" element={<Protected><FAQPage /></Protected>} />
                <Route path="/discounts" element={<Protected><DiscountsPage /></Protected>} />
                <Route path="/bonuses" element={<Protected><BonusesPage /></Protected>} />
                <Route path="/referral" element={<Protected><ReferralPage /></Protected>} />
                <Route path="/referral/program" element={<Protected><ReferralProgramPage /></Protected>} />
                <Route path="/referral/identity" element={<Protected><PartnerIdentityPage /></Protected>} />
            </Route>
        </Routes>
  );
}
